import mapImages from '@/util/mapImages'
import Util from '@/util'
// import ApiService from '@/util/api.service'
import RapidSOS from '@/assets/map/rapidsos.png'
import BaseStore from './baseStore'

const ol = window.ol

class IncidentStore extends BaseStore {
  constructor(map, source) {
    super(map, source)
    this.visibleCondition = { status: ['ACTIVO'] }
    this.hoveredId = null
    this.sosIncidents = new Map()

    this.categoryCount = {
      seguridad: 0,
      medico: 0,
      proteccion_civil: 0,
      servicios_publicos: 0
    }
    this.visibleConditionRules = {
      groupId: 'LIST',
      status: 'LIST',
      // category: 'LIST',
      uniqueId: 'STRING',
      disabled: 'BOOLEAN'
    }
  }

  _createMarker(item) {
    const marker = new ol.Feature({
      geometry: new ol.geom.Point(window.ol.proj.fromLonLat([
        item.longitude + Math.random() * 0.000001, item.latitude + Math.random() * 0.000001
      ])),
      name: item.id,
      population: 4000,
      rainfall: 500
    });
    item.typeOfItem = 'incidents'
    if (this.sosIncidents.has(item.uniqueId)) {
      item.typeOfItem = 'sosIncident'
      item.sosData = this.sosIncidents.get(item.uniqueId)
    }
    this.categoryCount[item.category]++
    marker.setId('incidents__' + item.id)
    marker.set('record', item)
    this.markers.set(item.id, marker)
    this._updateMarker(item)
    return marker
  }

  _updateMarker(item) {
    const tmpMarker = this.markers.get(item.id)
    item.statusTitle = Util.statusMap[item.status]
    tmpMarker.setStyle(this._getStyle(item))
    const record = tmpMarker.get('record')
    if (item.latitude !== record.latitude || item.longitude !== record.longitude) {
      tmpMarker.getGeometry().setCoordinates(window.ol.proj.fromLonLat([
        item.longitude, item.latitude
      ]))
    }
    const visible = this._isVisible(item)
    Object.assign(record, item)
    this.notify(item)
    this._updateVisbility(tmpMarker, visible)
  }

  updateMarker(item) {
    if (!this.markers.get(item.id)) {
      return this._createMarker(item)
    }
    const record = this.markers.get(item.id).get('record')
    item.typeOfItem = record.typeOfItem
    if (item.status === 'HISTORICO') {
      if (this.map.trip) {
        this.map.trip.emit('unsubscribecad', item.uniqueId)
      }
      this.categoryCount[item.category]--
      console.log('CLEAR TIEMOUT', record)
    }
    this._updateMarker(item)
    return null
  }

  _getStyle(item) {
    if (item.typeOfItem === 'sosIncident') {
      return this._getIcon(mapImages.incident.sos, item.name, {
        offsetY: -35,
        offsetX: 1
      })
    }
    const category = mapImages.incident
    let icon = null
    let scale = 0.6
    if (item.category && item.categoryData) {
      icon = item.categoryData.image
    }
    if (item.selected || this.hoveredId === item.id) {
      scale = 0.7
    }
    if (icon) {
      icon = (process.env.VUE_APP_IMAGES_PATH || '/api/v2/public/images/') + (icon.split('/').pop())
    } else {
      icon = category.seguridad
      scale = category.scale
    }
    return this._getIcon(icon, item.name, {
      // rotation: item.position ? item.position.course : 0,
      scale,
      offsetY: category.offsetY,
      offsetX: category.offsetX
    })
  }

  // _getStyle(item) {
  //   if (item.typeOfItem === 'sosIncident') {
  //     return this._getIcon(mapImages.incident.sos, item.name, {
  //       offsetY: -35,
  //       offsetX: 1
  //     })
  //   }
  //   if (item.rapidSosLocations && item.rapidSosLocations.length) {
  //     return this._getSosIcon({})
  //   }
  //   const category = mapImages.incident.seguridad
  //   let icon = null
  //   let scale = 0.6
  //   if (item.category && item.categoryData) {
  //     icon = item.categoryData.image
  //   } else {
  //     console.error(`Categoría de dispositivo no definido "${item.category}"`)
  //   }
  //   if (item.selected || this.hoveredId === item.id) {
  //     scale = 0.7
  //   }
  //   if (icon) {
  //     icon = (process.env.VUE_APP_IMAGES_PATH || '/api/v2/public/images/') + (icon.split('/').pop())
  //   } else {
  //     icon = category.up
  //     scale = 1
  //   }
  //   return this._getIcon(icon, item.name, {
  //     // rotation: item.position ? item.position.course : 0,
  //     scale,
  //     offsetY: category.offsetY,
  //     offsetX: category.offsetX
  //   })
  // }

  _getStyleSelected(item) {
    return this._getStyle(item)
  }

  _getSosIcon({ anchor = [6, 5], scale = 0.7 }) {
    return new ol.style.Style({
      image: new ol.style.Icon({
        anchor,
        anchorXUnits: 'pixels',
        anchorYUnits: 'pixels',
        src: RapidSOS,
        scale,
      }),
      zIndex: 20
    })
  }

  updateMarkersStyle() {
    this.markers.forEach((marker) => {
      marker.setStyle(this._getStyle(marker.get('record')))
    })
  }

  hoverMarker(id) {
    if (!id && this.hoveredId) {
      const marker = this.markers.get(this.hoveredId)
      this.hoveredId = null
      marker.setStyle(this._getStyle(marker.get('record')))
    } else if (id !== this.hoveredId) {
      this.hoveredId = id
      const marker = this.markers.get(id)
      marker.setStyle(this._getStyleSelected(marker.get('record')));
    }
  }
}
export default IncidentStore
